import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('edilservice_cookie_consent');
    
    if (!cookieConsent) {
      // Show banner after a short delay
      setTimeout(() => setIsVisible(true), 1000);
    } else if (cookieConsent === 'accepted') {
      // Load PostHog if consent was previously given
      loadPostHog();
    }

    // Listen for manual trigger to reopen banner
    const handleOpenBanner = () => {
      setIsVisible(true);
    };
    window.addEventListener('openCookieBanner', handleOpenBanner);

    return () => {
      window.removeEventListener('openCookieBanner', handleOpenBanner);
    };
  }, []);

  const loadPostHog = () => {
    // PostHog is already in index.html, just need to init if not already done
    if (window.posthog && !window.posthog.__loaded) {
      window.posthog.init("phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs", {
        api_host: "https://us.i.posthog.com",
        person_profiles: "identified_only",
        session_recording: false, // Mantenuto false come richiesto
      });
      window.posthog.__loaded = true;
    }
  };

  const handleAccept = () => {
    localStorage.setItem('edilservice_cookie_consent', 'accepted');
    loadPostHog();
    closeBanner();
  };

  const handleReject = () => {
    localStorage.setItem('edilservice_cookie_consent', 'rejected');
    // Don't load PostHog
    closeBanner();
  };

  const closeBanner = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <div 
      className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-300 ${
        isClosing ? 'translate-y-full opacity-0' : 'translate-y-0 opacity-100'
      }`}
    >
      <div className="bg-slate-900 text-white shadow-2xl border-t border-slate-700">
        <div className="container mx-auto px-4 py-6 max-w-6xl">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="flex-1">
              <p className="text-sm md:text-base leading-relaxed">
                Usiamo <strong>cookie tecnici</strong> necessari al funzionamento del sito e, previo consenso, <strong>cookie di analisi (PostHog)</strong> per capire come viene usato il sito.{' '}
                <Link to="/cookie-policy" className="text-orange-400 hover:text-orange-300 underline font-medium">
                  Leggi la nostra Cookie Policy
                </Link>
                .
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 min-w-fit">
              <button
                onClick={handleReject}
                className="px-6 py-2.5 bg-slate-700 hover:bg-slate-600 text-white rounded-lg transition-colors font-medium text-sm whitespace-nowrap"
              >
                Solo necessari
              </button>
              <button
                onClick={handleAccept}
                className="px-6 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-lg transition-colors font-medium text-sm whitespace-nowrap"
              >
                Accetta
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
